import { legacyMode } from 'App'
import { parse, stringify } from 'query-string'
import { navigate } from '@reach/router'
import { navigateToAphrodite } from './navigateToAphrodite'

const location = window.location

const Navigator = {
  projections: ({ city }: { city?: string }) => {
    legacyMode ? navigateToAphrodite(`projections&city=${city}`) : navigate('/projections')
  },
  stack: ({
    planId,
    city,
    buildingId,
    floorId,
  }: {
    planId?: string
    city?: string
    buildingId?: string
    floorId?: string
  }) => {
    if (city) city = encodeURI(city)
    navigateToAphrodite(
      `stack&planId=${planId}&city=${city}&buildingId=${buildingId}$floorId=${floorId}`
    )
  },
  floorPlan: ({ planId, floorId }: { floorId: string; planId?: string }) => {
    if (legacyMode) {
      navigateToAphrodite(`floor_map&floorId=${floorId}&planId=${planId}`)
      return
    }
    let url = `/floor_plan/${floorId}`
    if (planId) url = `${url}/ap/${planId}`
    navigate(url)
  },
  portfolio: ({
    buildingId,
    floorId,
    tab,
    apId,
  }: {
    buildingId?: string
    floorId?: string
    tab?: string
    apId?: string
  }) => {
    let url = '/portfolio'
    if (buildingId) {
      url = `${url}/${buildingId}`
      if (floorId) url = `${url}/${floorId}`
    }
    if (tab || apId) url = `${url}?${stringify({ tab, apId })}`
    navigate(url)
  },
  buildingManagement: ({ buildingId, floorId }: { buildingId?: string; floorId?: string }) => {
    legacyMode ? navigateToAphrodite('manage/buildings') : navigate('/buildingManager')
  },
  lease: ({ leaseId }: { leaseId: string }) => {
    const search = parse(location.search)
    search.leaseId = leaseId
    navigate(`${location.pathname}?${stringify(search)}`)
  },
  quickBuilding: ({ buildingId }: { buildingId: string }) => {
    const search = parse(location.search)
    search.buildingId = buildingId
    navigate(`${location.pathname}?${stringify(search)}`)
  },
  quickFloor: ({ floorId }: { floorId: string }) => {
    const search = parse(location.search)
    search.floorId = floorId
    navigate(`${location.pathname}?${stringify(search)}`)
  },
}
export default Navigator
